import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export const useOriAliases = () => {
    return useBootstrapState()?.oriAliasOptions ?? [];
};
